// mantine
import { Drawer, UnstyledButton, Button, Textarea } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
// utils
import { generateReport } from '@newo/toolkit/report';
import { useLocation } from 'react-router-dom';
import { useProfileQuery } from '@/services/customer/profile/profile.queries';
import useActReportDrawerStore from '@/modules/ActReportDrawer/ActReportDrawer.store.ts';
import { PATHS } from '@/constants';

const ActReportDrawer = () => {
    const clipboard = useClipboard({ timeout: 500 });
    const act = useActReportDrawerStore((state) => state.act);
    const selectActToReport = useActReportDrawerStore(
        (state) => state.selectActToReport
    );

    const location = useLocation();
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);
    const { data: profile } = useProfileQuery(!isCreatePartnerPage);
    const report = act && profile ? generateReport(act, profile) : '';

    const handleCopy = () => {
        clipboard.copy(report);
    };

    const handleCancel = () => {
        selectActToReport();
    };

    return (
        <Drawer
            withOverlay
            opened={!!act}
            position="right"
            size="lg"
            title="Report"
            onClose={handleCancel}
        >
            <div className="flex flex-col gap-4">
                <Textarea
                    readOnly
                    rows={20}
                    styles={{ input: { fontFamily: 'monospace' } }}
                    value={report}
                />

                <div className="flex justify-between gap-2">
                    <UnstyledButton
                        className="text-xs text-gray-6"
                        onClick={handleCancel}
                    >
                        Cancel
                    </UnstyledButton>
                    <Button size="xs" type="submit" onClick={handleCopy}>
                        {clipboard.copied ? 'Copied' : 'Copy'}
                    </Button>
                </div>
            </div>
        </Drawer>
    );
};

export default ActReportDrawer;
